import { Validator } from '@vista-digital/validator';
import { ItemPickerItemOptionQuantityInputType } from './item-option-quantity-input-type';
/**
 * Default config specific to parent sales item options.
 */
export const defaultItemPickerParentSalesItemOptionsConfig = {
    showImages: true,
    quantityInputType: ItemPickerItemOptionQuantityInputType.Number
};
export const itemPickerParentSalesItemOptionsConfigValidator = Validator.object({
    showImages: Validator.boolean(),
    quantityInputType: Validator.oneOf(Object.values(ItemPickerItemOptionQuantityInputType))
});
